<template>
  <b-modal
    :id="id"
    :title="title"
    :centered="centered"
    :hide-footer="hideFooter"
    :hide-header-close="hideHeaderClose"
    :no-close-on-backdrop="noCloseOnBackdrop"
    title-class="text-center"
    @close="closeHandler"
  >
    <div class="d-block text-center">
      <slot name="body"></slot>
    </div>
    <div class="mt-3 d-flex flex-row justify-content-center align-items-center">
      <slot name="row-buttons"></slot>
    </div>
  </b-modal>
</template>

<script>
  export default {
    props: {
      id: String,
      title: String,
      centered: {
        default: false,
        type: Boolean,
      },
      hideFooter: {
        default: false,
        type: Boolean,
      },
      hideHeaderClose: {
        default: false,
        type: Boolean,
      },
      noCloseOnBackdrop: {
        default: false,
        type: Boolean,
      },
      closeHandler: {
        default: () => {},
        type: Function,
      },
    },
  }
</script>